import { render, staticRenderFns } from "./mysetting.vue?vue&type=template&id=03ed777a&scoped=true&"
import script from "./mysetting.vue?vue&type=script&lang=js&"
export * from "./mysetting.vue?vue&type=script&lang=js&"
import style0 from "./mysetting.vue?vue&type=style&index=0&id=03ed777a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ed777a",
  null
  
)

export default component.exports